/**
 * GIWAHS Adaptive Journey Core Engine — JourneyState (AJIP-16.02.003 · WS3)
 * ---------------------------------------------------------------------
 * Canonical journey state model. Frozen. Reusable across every journey
 * type. Definitions do not vary between journeys.
 *
 * States
 *   NOT_STARTED, STARTED, IN_PROGRESS, WAITING, BLOCKED,
 *   COMPLETED, CANCELLED, FAILED
 *
 * Terminal states cannot be exited by a normal transition.
 */

const STATES = Object.freeze({
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING: 'WAITING',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
});

const ALL_STATES = Object.freeze(Object.values(STATES));
const TERMINAL_STATES = Object.freeze([STATES.COMPLETED, STATES.CANCELLED, STATES.FAILED]);

const isValidState = (candidate) => ALL_STATES.includes(candidate);
const isTerminalState = (candidate) => TERMINAL_STATES.includes(candidate);

export { STATES, ALL_STATES, TERMINAL_STATES, isValidState, isTerminalState };
